<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px" size="small">
      <el-form-item label="声明编号" prop="confNums">
        <el-input v-model="formData.confNums" placeholder="请输入声明编号，多个用逗号分隔"></el-input>
      </el-form-item>
      <el-form-item label="是否上传成功" prop="uploadSuccess">
        <el-select v-model="formData.uploadSuccess" placeholder="请选择是否上传成功" style="width: 100%;">
          <el-option label="成功" value="1"></el-option>
          <el-option label="失败" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上传失败原因" prop="uploadFailReason" v-if="formData.uploadSuccess === '0'">
        <el-input v-model="formData.uploadFailReason" type="textarea" :rows="3" placeholder="请输入上传失败原因"></el-input>
      </el-form-item>
      <el-form-item label="上传日期" prop="uploadDate">
        <el-date-picker v-model="formData.uploadDate" type="date" placeholder="选择上传日期" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="上传人" prop="uploadPerson">
        <el-input v-model="formData.uploadPerson" placeholder="请输入上传人" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">{{ isEdit ? '修 改' : '保 存' }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveConformanceUploadRecord, updateConformanceUploadRecord, queryConformanceUploadRecordDetail } from '@/api/contract/contract';

export default {
  name: 'ConformanceDialog',
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '状态调整',
      isEdit: false,
      submitLoading: false,
      formData: {
        uploadRecordPid: undefined,
        confNums: '',
        uploadSuccess: undefined,
        uploadFailReason: undefined,
        uploadDate: undefined,
        uploadPerson: undefined,
        uploadPersonPid: undefined,
        remark: undefined
      },
      rules: {
        confNums: [
          { required: true, message: '请输入声明编号', trigger: 'blur' }
        ],
        uploadSuccess: [
          { required: true, message: '请选择是否上传成功', trigger: 'change' }
        ],
        uploadFailReason: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.uploadSuccess === '0' && !value) {
                callback(new Error('上传失败时，失败原因不能为空'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        uploadDate: [
          { required: true, message: '请选择上传日期', trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    'formData.uploadSuccess' (newVal) {
      if (newVal === '1') {
        this.formData.uploadFailReason = undefined;
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate('uploadFailReason');
      }
    }
  },
  methods: {
    openDialog (type, row = null, selectedRows = []) {
      this.isEdit = type === 'edit';
      this.dialogTitle = this.isEdit ? '修改符合性声明上传记录' : '状态调整';
      this.dialogVisible = true;

      if (this.isEdit && row) {
        // 修改模式：加载现有记录详情
        this.loadDetail(row.uploadRecordPid);
      } else {
        // 状态调整或新增模式：提取声明编号
        const confNums = Array.isArray(selectedRows)
          ? selectedRows.map(item => item.confNum).filter(Boolean).join(',')
          : '';
        this.resetForm(confNums);
      }
    },
    loadDetail (uploadRecordPid) {
      queryConformanceUploadRecordDetail({ uploadRecordPid }).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const data = res.additionalData;
          this.formData = {
            uploadRecordPid: data.uploadRecordPid,
            confNums: data.confNums || data.confNum || '',
            uploadSuccess: data.uploadSuccess ? String(data.uploadSuccess) : undefined,
            uploadFailReason: data.uploadFailReason,
            uploadDate: data.uploadDate ? data.uploadDate.split(' ')[0] : undefined,
            uploadPerson: data.uploadPerson,
            uploadPersonPid: data.uploadPersonPid,
            remark: data.remark
          };
        } else {
          this.$message.error((res && res.retMsg) || '获取详情失败');
        }
      }).catch(error => {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      });
    },
    resetForm (confNums = '') {
      const userName = this.$store.state.loginUser?.userName || '';
      const userPkid = this.$store.state.loginUser?.userPkid || '';
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const todayStr = `${year}-${month}-${day}`;

      this.formData = {
        uploadRecordPid: undefined,
        confNums,
        uploadSuccess: '1', // 默认上传成功
        uploadFailReason: undefined,
        uploadDate: todayStr, // 默认当天
        uploadPerson: userName, // 默认当前操作员
        uploadPersonPid: userPkid,
        remark: undefined
      };

      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const submitData = {
          confNums: this.formData.confNums,
          uploadSuccess: this.formData.uploadSuccess,
          uploadFailReason: this.formData.uploadFailReason || '',
          uploadDate: this.formData.uploadDate,
          uploadPerson: this.formData.uploadPerson,
          uploadPersonPid: this.formData.uploadPersonPid,
          remark: this.formData.remark || ''
        };
        if (this.isEdit) {
          submitData.uploadRecordPid = this.formData.uploadRecordPid;
        }

        const apiCall = this.isEdit ? updateConformanceUploadRecord(submitData) : saveConformanceUploadRecord(submitData);
        apiCall.then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success(this.isEdit ? '修改成功' : '保存成功');
            this.dialogVisible = false;
            this.$emit('refresh');
          } else {
            this.$message.error((res && res.retMsg) || (this.isEdit ? '修改失败' : '保存失败'));
          }
          this.submitLoading = false;
        }).catch(error => {
          console.error('保存失败:', error);
          this.$message.error(this.isEdit ? '修改失败' : '保存失败');
          this.submitLoading = false;
        });
      });
    },
    handleCancel () {
      this.dialogVisible = false;
    },
    handleClose () {
      this.resetForm();
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
